import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "34560bdd-867b-4bd6-9d07-95172e998506",
    authority: "https://login.microsoftonline.com/619800fc-aad5-437c-8447-2710e029771e",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
};